<ng-container *ngIf="order$ | async as order">
  <ng-container *ngIf="!order.isB2BOrder">
    <a
      sdButton
      type="accent"
      data-analytics="catalog"
      [fullWidth]="true"
      [routerLink]="{ cxRoute: 'category', params: { code: 'stroitelnye-materialy-5521' } } | cxUrl"
    >
      Не сдамся
    </a>
  </ng-container>
</ng-container>
